import {PlatformsService} from '@core/services/platforms.service';
import {Meta, Title} from '@angular/platform-browser';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    private readonly _defaultCompany = 'Media Evolution';
    private readonly _defaultTitle = 'Dashboard';
    private readonly _defaultDescription = 'Hèt dashboard voor video platforms.';

    constructor(private _meta: Meta,
                private _title: Title,
                private _platforms: PlatformsService) {
    }

    async set(meta: SiteMetaTags = {}) {
        // Get the platform.
        const platform = await this._platforms.getPlatform();

        // Get the company, title and description.
        const company = platform && platform.title ? platform.title : this._defaultCompany;
        const title = `${meta.title || this._defaultTitle} • ${company}`;
        const description = meta.description || this._defaultDescription;

        // Update the site name tag.
        this._meta.updateTag({property: 'og:site_name', content: company});

        // Update the title tags.
        this._title.setTitle(title);
        this._meta.updateTag({property: 'og:title', content: title});

        // Update all descriptions.
        this._meta.updateTag({name: 'description', content: description});
        this._meta.updateTag({property: 'og:description', content: description});
    }

}

export interface SiteMetaTags {

    title?: string;
    description?: string;

}